export default {
  namespaced: true,
  state: {
    tenantInfo: {},
    direction: 'rtl'
  },
  getters: {
    isRTL (state: any) {
      return state.direction === 'rtl'
    },
    direction (state: any) {
      return state.direction
    },
    tenantInfo (state: any) {
      return state.tenantInfo
    },
    defaultLanguageName (state: any) {
      if (!state.tenantInfo || !state.tenantInfo.defaultLanguage) {
        return 'Fa'
      }

      return state.tenantInfo.defaultLanguage
    },
    fallbackLanguageName (state: any) {
      if (!state.tenantInfo || !state.tenantInfo.languages) {
        return 'En'
      }

      if (state.tenantInfo.languages.length === 0) return 'En'
      else if (state.tenantInfo.languages.length === 1) return 'En'
      else return state.tenantInfo.languages[2]
    },
    setDirection (state: any, payload: any) {
      state.direction = payload
    }
  },
  mutations: {
    setDirection (state: any, payload: any) {
      state.direction = payload
    },
    tenantInfoReceived (state: any, tenantInfo: any) {
      state.tenantInfo = tenantInfo
    }
  }
}
